var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        centered: "",
        "hide-header-close": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        scrollable: "",
        size: "lg"
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _c("span", { staticClass: "header-title" }, [
          _vm._v(_vm._s(_vm.documentName))
        ])
      ]),
      _c("div", { staticClass: "document-viewer" }, [
        _c("iframe", {
          attrs: {
            id: "pdfViewer",
            src: "./pdfjs/web/viewer.html",
            title: "PDF Viewer"
          }
        })
      ]),
      _c(
        "div",
        { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
        [
          _c("action-button", {
            attrs: {
              i: "fas fa-times-circle",
              text: "Cerrar",
              variant: "outline-danger"
            },
            on: {
              click: function($event) {
                return _vm.closeModal()
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }